import { ngModuleRegistrar } from '../../helpers';
import { MiddlewareServiceProvider as MiddlewareService } from './index';

export default ngModuleRegistrar('provider', {
    MiddlewareService
});


// WEBPACK FOOTER //
// ./src/middleware/services/register.js